export const gamesEndpointIds = {
    GET_GAMES_STATS: 'GET_GAMES_STATS',
    RESET_GAMES_STATS_QUOTA: 'RESET_GAMES_STATS_QUOTA',
};
